import qs from 'qs'
import {Serializer as JSONAPISerializer} from "jsonapi-serializer";
import {deserialize} from 'json-api-deserialize';
import {deserialize as deserializeV2} from "deserialize-json-api";
import {snakeCase} from 'lodash';


export default {
    data() {
        return {
            pagination: {
                currentPage: 1,
                perPage: 10,
                from: 1,
                to: 10,
                total: 0,
                lastPage: 1
            },
            isBusy: false,
        };
    },
    mounted() {
        if (this.$route.query.page) {
            console.log('currentPage', this.$route.query.page);
            this.pagination.currentPage = this.$route.query.page;
            console.log('pagination', this.pagination.currentPage);
        }
    },
    methods: {
        ctxParams: function (ctx, include = null) {
            return {
                include: include ? include : undefined,
                page: ctx.currentPage,
                limit: ctx.perPage,
                filters: ctx.filter,
                order: ctx.sortBy ? [{
                    by: ctx.sortBy,
                    dir: ctx.sortDesc ? 'asc' : 'desc'
                }] : undefined
            };
        },
        ctxParamsV2: function (ctx, include = null) {
          return {
                include: include ? include : undefined,
                page: ctx.currentPage,
                limit: ctx.perPage,
                filter: ctx.filter,
                sort: ctx.sortBy ? ((ctx.sortDesc ? '-' : '') + ctx.sortBy) : undefined
            };
        },

        ctxQueryString: function (ctx, include = '') {
            const params = this.ctxParams(ctx);
            return this.queryString(params, include)
        },

        ctxQueryStringV2: function (ctx, include = '') {
            const params = this.ctxParamsV2(ctx);
            return this.queryString(params, include)
        },

        deserializeV2: function (jsonApiData, paginated = false) {
          let data = deserializeV2(jsonApiData).data;
          if (paginated)
                this.pagination = deserialize(jsonApiData).meta.pagination;
          return data;
        },

        imgProps(url) {
            return { blank: !url, blankColor: '#777', width: 60, height: 60, class: '', src: url }
        },

        queryString: function (params, include = null) {
            if (include)
                params['include'] = include;

            if(params['sortBy']) {
              const sortType = params['sortDesc'] ? '-' : '';
              params['sort'] = `${sortType}${snakeCase(params['sortBy'])}`;
            }

            return qs.stringify(params, { encode: false, skipNulls: true, filter: function (prefix, value) {
                    if(prefix === 'filter') {
                        for (var propName in value) {
                            if (value[propName] === null || value[propName] === undefined || value[propName] === "") {
                                delete value[propName];
                            }
                        }
                    }
                    return value;
                }})
        },

        deserialize: function (jsonApiData, paginated = false) {
            if (paginated)
                this.pagination = deserialize(jsonApiData).meta.pagination;
            return deserialize(jsonApiData).data;
        },
        deserializeJsonApi: function (jsonApiData, paginated = false, keyForAttribute = 'camelCase') {
            if (paginated)
                this.pagination = deserialize(jsonApiData).meta.page;
            return deserialize(jsonApiData).data;
        },

        serialize: async function (collectionName, attributes, data, keyForAttribute = 'camelCase') {
            return new JSONAPISerializer(collectionName, {
                attributes: attributes,
                keyForAttribute: keyForAttribute
            }).serialize(data);
        },

        camelToSnakeCase: function (str) {
            return str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
        },

        resetPagination: function () {
            this.pagination.currentPage = 1;
        },

        preparePaginationQuery(ctx, include) {
          return {
            ...(ctx.filter ?? {}),
            include,
            sort_by: ctx.sortBy ? ctx.sortBy : undefined,
            order_by: ctx.sortBy
              ? ctx.sortDesc
                ? 'desc'
                : 'asc'
              : undefined,
            page: this.pagination.currentPage,
            per_page: this.pagination.perPage,
          }
        },

        updatePaginationMeta(data) {
          this.pagination.currentPage = data.meta.current_page;
          this.pagination.perPage = data.meta.per_page;
          this.pagination.from = data.meta.from;
          this.pagination.to = data.meta.to;
          this.pagination.total = data.meta.total;
          this.pagination.lastPage = data.meta.last_page;
        },

        parseBackendErrors(errors) {
            if (!errors) return;
            this.$nextTick(() => {
                Object.keys(errors).forEach(key => {
                    if (errors[key][0]) {
                        this.$validator.errors.add({
                            field: key,
                            msg: errors[key][0],
                        });
                        this.$validator.fields.find({name: key}).setFlags({
                            pending: false,
                            valid: false,
                            validated: true
                        });
                    }
                });
            })
        },

        // useful to map a nested object
        objMapDeeply: function (map) {
          const objMapDeeply = this.objMapDeeply;
          return function(obj, fn) {
            return map(_.mapValues(obj, function (v) {
              return _.isPlainObject(v) ? objMapDeeply(map)(v, fn) : v;
            }), fn);
          }
        },

    },
    watch: {
        'pagination.currentPage': function (newPage) {
            this.$router.push({query: {...this.$route.query, page: newPage}});
        }
    }
}
